import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange, handleSqsMessageBatchSizeChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { genericS3ThrottleEnabled, overrideSource, sqsMessageBatchSize } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  const internalHandleSqsBatchSizeChange = (e) => {
    const { value } = e.target;
    onChange(e, formData);
    if (value >= 1 && value <= 10) {
      handleSqsMessageBatchSizeChange("");
    } else {
      handleSqsMessageBatchSizeChange(t("common.validation.sqs_batch_size_range"));
    }
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("common.fields.advanced_options"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(
      ThrottlingCheckbox,
      {
        id: "genericS3ThrottleEnabled",
        defaultChecked: genericS3ThrottleEnabled == null ? void 0 : genericS3ThrottleEnabled.value,
        onChange
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "overrideSource",
        type: "text",
        value: overrideSource == null ? void 0 : overrideSource.value,
        onChange,
        label: t("genericS3.fields.override_source"),
        help: t("genericS3.fields.override_source_help")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "sqsMessageBatchSize",
        type: "number",
        min: "1",
        value: sqsMessageBatchSize == null ? void 0 : sqsMessageBatchSize.value,
        onChange: internalHandleSqsBatchSizeChange,
        label: t("common.fields.sqs_message_batch_size"),
        help: t("common.fields.sqs_message_batch_size_help")
      }
    )
  );
};
export default FormAdvancedOptions;
